import * as React from 'react';

export const AppIcon: React.FC = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect y="14.821" width="11.2527" height="38.4" fill="white" />
            <rect x="14.0659" y="8.75793" width="11.2527" height="44.4632" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M51.3407 27.6211H57.6703L58.3736 29.979H50.6374L51.3407 27.6211ZM40.0881 27.9579H33.7585L33.0552 30.3158H40.7914L40.0881 27.9579ZM39.8321 52.5474H31.2007L30.2417 56.5895H40.7912L39.8321 52.5474ZM50.8931 52.5474H59.5245L60.4835 56.5895H49.9341L50.8931 52.5474ZM62.4658 57.9368H48.6556L47.1211 64H64.0002L62.4658 57.9368ZM28.9632 57.9368H42.7734L44.3078 64H27.4287L28.9632 57.9368ZM60.0999 35.0316H31.3286L28.1318 51.2H63.2967L60.0999 35.0316ZM57.0951 31.6632H51.9162L51.3408 33.6842H57.6705L57.0951 31.6632ZM34.3337 31.6632H39.5125L40.088 33.6842H33.7583L34.3337 31.6632Z"
                fill="white"
            />
            <path fillRule="evenodd" clipRule="evenodd" d="M39.3846 0H28.1318V33.0105H30.9448V24.2526H39.3846V0Z" fill="white" />
        </svg>
    );
};
